(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const B = window.budi || {};
  const money = (cents) => {
    const fmt = B.moneyFormat || '${{amount}}';
    const n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  };

  // Auto-apply trade discount code for trade customers (once per session)
  if (B.isTrade && B.tradeCode) {
    let done = false;
    try { done = sessionStorage.getItem('budiTrade') === B.tradeCode; } catch (e) {}
    if (!done) {
      fetch('/discount/' + encodeURIComponent(B.tradeCode) + '?redirect=/cart.js', { credentials: 'same-origin' })
        .then(() => { try { sessionStorage.setItem('budiTrade', B.tradeCode); } catch (e) {} })
        .catch(() => {});
    }
  }

  // Drawer
  const drawer = $('[data-drawer]');
  const setDrawer = (open) => { if (!drawer) return; drawer.classList.toggle('is-open', open); drawer.setAttribute('aria-hidden', !open); document.body.style.overflow = open ? 'hidden' : ''; };
  $$('[data-drawer-open]').forEach(b => b.addEventListener('click', () => setDrawer(true)));
  $$('[data-drawer-close]').forEach(b => b.addEventListener('click', () => setDrawer(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setDrawer(false); });

  // Hero slider
  $$('[data-slider]').forEach(root => {
    const slides = $$('[data-slide]', root), dots = $$('[data-dot]', root);
    if (slides.length < 2) return;
    let i = 0;
    const go = (n) => { i = (n + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === i)); dots.forEach((d, k) => d.classList.toggle('is-active', k === i)); };
    $('[data-prev]', root)?.addEventListener('click', () => go(i - 1));
    $('[data-next]', root)?.addEventListener('click', () => go(i + 1));
    dots.forEach(d => d.addEventListener('click', () => go(+d.dataset.dot)));
    setInterval(() => { if (!document.hidden) go(i + 1); }, 6000);
  });

  // Carousels
  $$('[data-carousel]').forEach(root => {
    const track = $('[data-track]', root); if (!track) return;
    const step = () => track.clientWidth * 0.8;
    $('[data-prev]', root)?.addEventListener('click', () => track.scrollBy({ left: -step() }));
    $('[data-next]', root)?.addEventListener('click', () => track.scrollBy({ left: step() }));
  });

  // Wishlist (per-browser convenience)
  let wish = [];
  try { wish = JSON.parse(localStorage.getItem('budiWish') || '[]'); } catch (e) {}
  $$('[data-wish]').forEach(b => {
    if (wish.includes(b.dataset.wish)) b.classList.add('is-on');
    b.addEventListener('click', () => {
      const h = b.dataset.wish; const on = !wish.includes(h);
      wish = on ? [...wish, h] : wish.filter(x => x !== h);
      b.classList.toggle('is-on', on);
      try { localStorage.setItem('budiWish', JSON.stringify(wish)); } catch (e) {}
    });
  });

  // Toast + cart count
  const toast = document.createElement('div'); toast.className = 'toast'; document.body.appendChild(toast);
  const showToast = (msg) => { toast.innerHTML = msg + ' <a href="' + (B.routes?.cart || '/cart') + '">View cart</a>'; toast.classList.add('is-show'); clearTimeout(showToast.t); showToast.t = setTimeout(() => toast.classList.remove('is-show'), 3200); };
  const refreshCart = () => fetch('/cart.js').then(r => r.json()).then(c => { $$('[data-cart-count]').forEach(el => el.textContent = money(c.total_price)); });
  const addToCart = (id, qty) => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +qty || 1 }] }) })
    .then(r => r.json().then(j => { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; }));

  $$('[data-quick-add]').forEach(btn => btn.addEventListener('click', () => {
    const label = btn.innerHTML; btn.disabled = true; btn.textContent = 'Adding…';
    addToCart(btn.dataset.quickAdd, 1).then(() => { showToast('Added to cart'); refreshCart(); })
      .catch(e => showToast(e.message)).finally(() => { btn.disabled = false; btn.innerHTML = label; });
  }));

  // Qty steppers
  $$('[data-qty]').forEach(b => b.addEventListener('click', () => {
    const input = b.parentElement.querySelector('input'); const min = +input.min || 0;
    input.value = Math.max(min, (+input.value || 0) + (+b.dataset.qty));
  }));

  // Product page
  const pdp = $('[data-product]');
  if (pdp) {
    const data = JSON.parse($('[data-product-json]').textContent);
    const form = $('[data-product-form]', pdp);
    const pct = +pdp.dataset.tradePct || 0;
    const idInput = $('[data-variant-id]', pdp);
    const mainImg = $('[data-main-image] img', pdp);
    const update = () => {
      const chosen = $$('[data-option]:checked', pdp).map(i => i.value);
      const v = data.variants.find(x => x.options.every((o, k) => o === chosen[k]));
      const btn = $('[data-add-btn]', pdp), lbl = $('[data-add-label]', pdp);
      if (!v) { btn.disabled = true; lbl.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      btn.disabled = !v.available; lbl.textContent = v.available ? 'Add to cart' : 'Coming soon';
      $('[data-sku]', pdp).textContent = v.sku ? 'SKU: ' + v.sku : '';
      $('[data-stock]', pdp).textContent = v.available ? '● In stock' : 'Coming soon';
      const trade = $('[data-trade-price]', pdp), retail = $('[data-retail-price]', pdp);
      if (trade) { trade.textContent = money(Math.floor(v.price * (100 - pct) / 100)); retail.textContent = money(v.price); }
      else if (retail) retail.textContent = money(v.price);
      if (v.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = v.image; }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    };
    $$('[data-option]', pdp).forEach(i => i.addEventListener('change', update));
    $$('[data-thumb]', pdp).forEach(t => t.addEventListener('click', () => {
      $$('[data-thumb]', pdp).forEach(x => x.classList.remove('is-active')); t.classList.add('is-active');
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.thumb; }
    }));
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      const btn = $('[data-add-btn]', pdp); btn.disabled = true;
      addToCart(idInput.value, form.querySelector('[name=quantity]').value)
        .then(() => { showToast('Added to cart'); refreshCart(); })
        .catch(err => showToast(err.message)).finally(() => { btn.disabled = false; });
    });
  }

// Category bar scroll arrows
$$('[data-catnav]').forEach(nav => {
const track = $('[data-catnav-track]', nav); if (!track) return;
const upd = () => { nav.classList.toggle('can-prev', track.scrollLeft > 4); nav.classList.toggle('can-next', track.scrollLeft + track.clientWidth < track.scrollWidth - 4); };
$('[data-catnav-prev]', nav)?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * 0.7 }));
$('[data-catnav-next]', nav)?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * 0.7 }));
track.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
});

// Announcement rotation
$$('[data-announce]').forEach(root => {
const msgs = $$('[data-announce-msg]', root); if (msgs.length < 2) return;
let i = 0; setInterval(() => { if (document.hidden) return; msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
});
})();

// ===== Product page v2 =====
(function(){
var root=document.querySelector('.pdp2'); if(!root) return;
var q=function(s,r){return (r||document).querySelector(s)}, qa=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))};
var fmt=(window.budi&&window.budi.moneyFormat)||'${{amount}}';
var money=function(c){var n=(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/,n);};
// tabs
qa('[data-tab]',root).forEach(function(b){b.addEventListener('click',function(){qa('[data-tab]',root).forEach(function(x){x.setAttribute('aria-selected',x===b)});qa('[data-panel]',root).forEach(function(p){p.classList.toggle('is-active',p.dataset.panel===b.dataset.tab)});});});
// gallery dots (mobile swipe)
var g=q('[data-gallery]',root), dots=qa('[data-gallery-dots] span',root);
if(g&&dots.length){g.addEventListener('scroll',function(){var i=Math.round(g.scrollLeft/g.clientWidth);dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)});},{passive:true});}
// variant -> scroll to its image
qa('[data-option]',root).forEach(function(inp){inp.addEventListener('change',function(){try{var data=JSON.parse(q('[data-product-json]').textContent);var chosen=qa('[data-option]:checked',root).map(function(i){return i.value});var v=data.variants.find(function(x){return x.options.every(function(o,k){return o===chosen[k]})});if(v&&v.media){var shot=q('[data-media-id="'+v.media+'"]',root);if(shot){g.scrollTo({left:shot.offsetLeft,behavior:'smooth'})}}
var lbl=q('.field-label strong',inp.closest('.option-pills').previousElementSibling.parentNode);}catch(e){}});});
// frequently bought together
var fbt=q('[data-fbt]',root);
if(fbt){var tot=q('[data-fbt-total]',fbt);var upd=function(){var s=0;qa('[data-fbt-id]',fbt).forEach(function(c){if(c.checked)s+=+c.dataset.fbtPrice});tot.textContent=money(s);};qa('input[type=checkbox]',fbt).forEach(function(c){c.addEventListener('change',upd)});upd();
q('[data-fbt-add]',fbt).addEventListener('click',function(){var btn=this;var items=qa('[data-fbt-id]',fbt).filter(function(c){return c.checked}).map(function(c){return {id:+c.dataset.fbtId,quantity:1}});btn.disabled=true;var old=btn.textContent;btn.textContent='Adding…';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:items})}).then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||'Could not add');return j})}).then(function(){btn.textContent='Added ✓';return fetch('/cart.js').then(function(r){return r.json()}).then(function(c){qa('[data-cart-count]').forEach(function(el){el.textContent=money(c.total_price)})});}).catch(function(e){btn.textContent=e.message}).finally(function(){setTimeout(function(){btn.disabled=false;btn.textContent=old},1800)});});}
// sticky add to cart
var bar=q('[data-sticky-atc]'), mainBtn=q('[data-add-btn]',root), form=q('[data-product-form]',root);
if(bar&&mainBtn&&'IntersectionObserver' in window){var io=new IntersectionObserver(function(es){es.forEach(function(e){var past=!e.isIntersecting&&e.boundingClientRect.top<0;bar.classList.toggle('is-show',past);bar.setAttribute('aria-hidden',!past);document.body.classList.toggle('has-sticky-atc',past);});},{threshold:0});io.observe(mainBtn);
q('[data-sticky-add]',bar).addEventListener('click',function(){if(form.requestSubmit)form.requestSubmit();else mainBtn.click();});}
})();

// ===== Product gallery slideshow: auto-rotate every 5s =====
(function(){
var root=document.querySelector('[data-gallery-root]'); if(!root) return;
var track=root.querySelector('[data-gallery]'); var shots=track.querySelectorAll('[data-shot]'); var n=shots.length; if(n<2) return;
var thumbs=Array.prototype.slice.call(document.querySelectorAll('[data-gal-thumb]'));
var dots=Array.prototype.slice.call(document.querySelectorAll('[data-gallery-dots] span'));
var bar=root.querySelector('[data-gal-progress]');
var delay=+root.dataset.autoplay||5000, idx=0, timer=null, paused=false, inView=true, resumeT=null;
var mark=function(i){ thumbs.forEach(function(t,k){t.classList.toggle('is-active',k===i)}); dots.forEach(function(d,k){d.classList.toggle('is-active',k===i)}); var t=thumbs[i]; if(t&&t.parentNode){ var p=t.parentNode; var l=t.offsetLeft-p.clientWidth/2+t.clientWidth/2; p.scrollTo({left:l,behavior:'smooth'}); } };
var go=function(i){ idx=(i+n)%n; track.scrollTo({left:idx*track.clientWidth,behavior:'smooth'}); mark(idx); restart(); };
var runBar=function(){ if(!bar) return; bar.classList.remove('is-run'); bar.style.transitionDuration='0ms'; bar.style.width='0'; void bar.offsetWidth; if(!paused&&inView&&!document.hidden){ bar.style.transitionDuration=delay+'ms'; bar.classList.add('is-run'); bar.style.width=''; } };
var restart=function(){ clearTimeout(timer); runBar(); if(paused||!inView||document.hidden) return; timer=setTimeout(function(){ go(idx+1); },delay); };
var pauseFor=function(ms){ paused=true; clearTimeout(timer); runBar(); clearTimeout(resumeT); if(ms) resumeT=setTimeout(function(){ paused=false; restart(); },ms); };
track.addEventListener('scroll',function(){ var i=Math.round(track.scrollLeft/track.clientWidth); if(i!==idx){ idx=i; mark(i); } },{passive:true});
thumbs.forEach(function(t){ t.addEventListener('click',function(){ go(+t.dataset.galThumb); pauseFor(10000); }); });
var p=root.querySelector('[data-gal-prev]'), nx=root.querySelector('[data-gal-next]');
if(p) p.addEventListener('click',function(){ go(idx-1); pauseFor(10000); });
if(nx) nx.addEventListener('click',function(){ go(idx+1); pauseFor(10000); });
root.addEventListener('mouseenter',function(){ pauseFor(0); });
root.addEventListener('mouseleave',function(){ paused=false; restart(); });
track.addEventListener('touchstart',function(){ pauseFor(8000); },{passive:true});
document.addEventListener('visibilitychange',restart);
if('IntersectionObserver' in window){ new IntersectionObserver(function(es){ inView=es[0].isIntersecting; restart(); },{threshold:.3}).observe(root); }
window.addEventListener('resize',function(){ track.scrollTo({left:idx*track.clientWidth}); });
if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ delay=8000; }
restart();
})();

// Footer: columns collapsed by default on phones
(function(){ if(window.matchMedia('(max-width:640px)').matches){ document.querySelectorAll('.ft__col[open]').forEach(function(d){ d.removeAttribute('open'); }); } })();

// Footer: keep columns open on desktop (no toggling)
document.querySelectorAll('.ft__col summary').forEach(function(s){ s.addEventListener('click',function(e){ if(window.matchMedia('(min-width:641px)').matches) e.preventDefault(); }); });


/* ===== Trade account application: input checks (added Oct 2026) ===== */
(function () {
  var form = document.getElementById('TradeForm');
  if (!form) return;
  function el(id) { return document.getElementById(id); }
  function attrs(node, a) { if (!node) return; for (var k in a) node.setAttribute(k, a[k]); }
  function label(id, text) { var l = form.querySelector('label[for="' + id + '"]'); if (l) l.textContent = text; }
  function digits(v) { return (v || '').replace(/\D/g, ''); }
  function field(id, text, input) {
    var d = document.createElement('div');
    var l = document.createElement('label'); l.setAttribute('for', id); l.textContent = text;
    d.appendChild(l); d.appendChild(input); return d;
  }
  function firstOption(select, text) {
    if (!select) return;
    var o = document.createElement('option'); o.value = ''; o.textContent = text; o.disabled = true; o.selected = true;
    select.insertBefore(o, select.firstChild); select.required = true;
  }

  var name = el('t-name'), email = el('t-email'), phone = el('t-phone'), company = el('t-company'),
      type = el('t-type'), state = el('t-state'), addr = el('t-addr'), ein = el('t-ein'),
      resale = el('t-resale'), web = el('t-web'), vol = el('t-vol'), notes = el('t-msg');

  attrs(name, { minlength: '2', maxlength: '80' });
  attrs(company, { minlength: '2', maxlength: '120' });
  attrs(email, { maxlength: '120', placeholder: 'you@yourbusiness.com', pattern: '[^@\\s]+@[^@\\s]+\\.[A-Za-z]{2,}', title: 'Enter a valid email address, e.g. you@yourbusiness.com' });
  attrs(phone, { inputmode: 'numeric', maxlength: '14', placeholder: '(555) 123-4567', title: '10-digit US phone number' });
  attrs(ein, { inputmode: 'numeric', maxlength: '10', placeholder: '12-3456789', title: 'EIN is 9 digits, e.g. 12-3456789', autocomplete: 'off' });
  if (ein) ein.required = true;
  label('t-ein', 'EIN / Federal Tax ID *');
  attrs(resale, { maxlength: '30', placeholder: 'Optional', pattern: '[A-Za-z0-9 \\-]{4,30}', title: '4 to 30 letters or numbers' });
  attrs(web, { maxlength: '200', placeholder: 'yourstore.com or marketplace link', pattern: '(https?://)?([A-Za-z0-9\\-]+\\.)+[A-Za-z]{2,}(/\\S*)?', title: 'Enter a website, e.g. yourstore.com' });
  attrs(notes, { maxlength: '1000' });
  firstOption(type, 'Select business type'); label('t-type', 'Business type *');
  firstOption(vol, 'Select expected monthly order'); label('t-vol', 'Expected monthly order *');

  /* State: dropdown of US states */
  if (state && state.tagName === 'INPUT') {
    var sel = document.createElement('select');
    attrs(sel, { 'class': 'input', id: 't-state', name: 'contact[State]', autocomplete: 'address-level1' });
    sel.required = true;
    var o0 = document.createElement('option'); o0.value = ''; o0.textContent = 'Select state'; o0.disabled = true; o0.selected = true; sel.appendChild(o0);
    'AL,AK,AZ,AR,CA,CO,CT,DE,DC,FL,GA,HI,ID,IL,IN,IA,KS,KY,LA,ME,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PA,RI,SC,SD,TN,TX,UT,VT,VA,WA,WV,WI,WY'.split(',').forEach(function (s) {
      var o = document.createElement('option'); o.value = s; o.textContent = s; sel.appendChild(o);
    });
    state.parentNode.replaceChild(sel, state);
    label('t-state', 'State *');
  }

  /* Address: street + city + ZIP, all required */
  if (addr) {
    addr.required = true;
    attrs(addr, { minlength: '5', maxlength: '120', placeholder: '123 Main St, Suite 4' });
    label('t-addr', 'Street address *');
    var city = document.createElement('input');
    attrs(city, { 'class': 'input', id: 't-city', name: 'contact[City]', autocomplete: 'address-level2', maxlength: '60' });
    city.required = true;
    var zip = document.createElement('input');
    attrs(zip, { 'class': 'input', id: 't-zip', name: 'contact[ZIP]', autocomplete: 'postal-code', inputmode: 'numeric', maxlength: '10', placeholder: '12345', pattern: '\\d{5}(-\\d{4})?', title: '5-digit ZIP code, e.g. 94568' });
    zip.required = true;
    var box = addr.parentNode;
    box.parentNode.insertBefore(field('t-zip', 'ZIP code *', zip), box.nextSibling);
    box.parentNode.insertBefore(field('t-city', 'City *', city), box.nextSibling);
    zip.addEventListener('input', function () {
      var d = digits(zip.value).slice(0, 9);
      zip.value = d.length > 5 ? d.slice(0, 5) + '-' + d.slice(5) : d;
    });
  }

  /* Phone: format as (555) 123-4567, must be 10 digits */
  function checkPhone() {
    var d = digits(phone.value);
    if (d.length === 11 && d.charAt(0) === '1') d = d.slice(1);
    d = d.slice(0, 10);
    phone.value = d.length > 6 ? '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6)
                : d.length > 3 ? '(' + d.slice(0, 3) + ') ' + d.slice(3) : d;
    phone.setCustomValidity(d.length === 10 && /[2-9]/.test(d.charAt(0)) ? '' : 'Enter a 10-digit US phone number, e.g. (555) 123-4567');
  }

  /* EIN: format as 12-3456789, must be 9 digits with a real IRS prefix */
  var BAD_EIN = ['00','07','08','09','17','18','19','28','29','49','69','70','78','79','89','96','97'];
  function checkEin() {
    var d = digits(ein.value).slice(0, 9);
    ein.value = d.length > 2 ? d.slice(0, 2) + '-' + d.slice(2) : d;
    var m = '';
    if (d.length !== 9) m = 'EIN must be 9 digits, e.g. 12-3456789';
    else if (BAD_EIN.indexOf(d.slice(0, 2)) > -1) m = 'That EIN does not look valid. Please check the number.';
    ein.setCustomValidity(m);
  }

  if (phone) { phone.addEventListener('input', checkPhone); phone.addEventListener('blur', checkPhone); }
  if (ein) { ein.addEventListener('input', checkEin); ein.addEventListener('blur', checkEin); }
  if (email) email.addEventListener('blur', function () { email.value = email.value.trim().toLowerCase(); });

  form.addEventListener('submit', function (e) {
    [name, company, addr, el('t-city'), resale, web, notes].forEach(function (i) { if (i) i.value = i.value.trim(); });
    if (phone) checkPhone();
    if (ein) checkEin();
    if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); }
  });
})();


/* ===== Trade form: explain resale certificate ===== */
(function () {
  var resale = document.getElementById('t-resale');
  if (!resale || document.getElementById('t-resale-help')) return;
  var help = document.createElement('small');
  help.id = 't-resale-help';
  help.style.cssText = 'display:block;margin-top:6px;font-size:12px;line-height:1.45;color:var(--muted,#666);';
  help.innerHTML = "<strong>What is this?</strong> A resale certificate (also called a seller’s permit or sales tax exemption certificate) is issued by your state’s tax department. It lets your business buy products you plan to resell without paying sales tax. " +
    "Don’t have one yet? You can still apply – leave this blank and we’ll explain the next steps.";
  resale.setAttribute('aria-describedby', 't-resale-help');
  resale.parentNode.appendChild(help);
})();
